import api from '../api';

const generate = async ({ id, name, email }: {
  id: string; name: string; email: string;
}): Promise<string> => {
  const response = await api.post('/coaching-sessions/jitsi-token', { id, name, email });
  return response.data.jwt;
};

export default generate;
